import * as React from "react";

const SvgIcnDefaultAvatarBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="currentColor" fillRule="nonzero">
            <path d="M12 13.756a5.86 5.86 0 110-11.72 5.86 5.86 0 010 11.72zm-2.762-3.694c.881.884 1.804 1.345 2.762 1.345s1.883-.46 2.771-1.343a.6.6 0 10-.846-.851c-.68.676-1.32.994-1.925.994-.604 0-1.24-.318-1.913-.992a.6.6 0 10-.85.847z" />
            <path d="M12.01 13.725c2.252-.013 4.162.69 5.699 2.103 1.547 1.425 2.348 3.27 2.392 5.498a.6.6 0 01-.62.611c-5.075.007-7.155.003-7.485 0-1.961-.014-7.178.007-7.51 0a.6.6 0 01-.587-.611c.044-2.228.845-4.073 2.392-5.498 1.54-1.417 3.455-2.12 5.713-2.103h.006z" />
        </g>
    </svg>
);

export default SvgIcnDefaultAvatarBold;
